import { render, staticRenderFns } from "./ChooseCoupon.vue?vue&type=template&id=b5e7a4dc&scoped=true&"
import script from "./ChooseCoupon.vue?vue&type=script&lang=js&"
export * from "./ChooseCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCoupon.vue?vue&type=style&index=0&id=b5e7a4dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e7a4dc",
  null
  
)

export default component.exports